import * as React from 'react';
import { Button } from '~features/ui';

import { ClaimCard } from '../ClaimCard';
import { DepositCard } from '../DepositCard';
import { WithdrawCard } from '../WithdrawCard';

export function ActionsCard({
  collapsed,
  symbol,
  lockDeposit = false,
  lockWithdraw = false,
  deprecated = false,
}: {
  collapsed: boolean;
  symbol: string;
  lockDeposit: boolean;
  lockWithdraw: boolean;
  deprecated: boolean;
}) {
  return (
    <div
      className={`duration-300 transition-height transform ${
        collapsed ? 'h-0' : 'h-full md:h-64'
      }`}>
      <div className="bg-dark1 bg-opacity-80 rounded-b-lg shadow-lg">
        <div
          className={`flex justify-items-stretch p-3 border-gray-500 border-opacity-30 
        border-t-2 flex-col md:flex-row space-y-3 md:space-y-0`}>
          <div className="md:w-1/3 p-3 order-2 md:order-1">
            <DepositCard symbol={symbol} lockDeposit={lockDeposit} />
          </div>
          <div className="md:w-1/3 p-3 order-1 md:order-2">
            <WithdrawCard symbol={symbol} lockWithdraw={lockWithdraw} />
          </div>
          {!(deprecated && symbol === 'LTY/BUSD') && (
            <div className="md:w-1/3 p-3 order-0 md:order-3">
              <ClaimCard />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
